// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1Qf_j","large":"styles_large__3n92N"};